module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEqSURBVHgBxVI7TsNAEJ1ZIC1b2oXRcgK4AQRoqEhukBtwBk7g+ARwA0xFQYKTEyRHMJ/CUFmBIlh4H2NHmCiyEqEUedIWM/vezsy+IVoDPB88OOZYwV5IVteyQSmA4dn7S1iE6jf/6Hg3iu0tRIiSV3MUG1bs9x3vuqrcc70Wg/2MsuZ5ksS0BPeOYxrcGFnYdllZhAcEjFcJC5QcUKhIHam/6Tmlf0LRGtiAmFnPifEkn9CKtNardJE2moFDsS4urYqM0XZqR1w+Sl0x9K6ZxHFx13ON2JjPKjHvwlKn2IXT5Hm/2rDZA9+XQulIOFBbKkAOHyxVwOOqY8oHk+ln0E7TlBfb6rt7PssI0pYR77uTr4+rglg3wvZiIkMWNLAj7SM8eXsd0hL8ACyUfPqbzlJLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bt1.png
// module id = A/vd
// module chunks = 1